import { render, staticRenderFns } from "./AddWardPage.vue?vue&type=template&id=a949d5b2&"
import script from "./AddWardPage.vue?vue&type=script&lang=js&"
export * from "./AddWardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports